<template>
  <div id="step-7-questionnaire">
    <questionnaire-component
      :questionnaire="questionnaire"
    />
  </div>
</template>

<script>
import QuestionnaireComponent from '../components/QuestionnaireComponent.vue';

export default {
  name: 'Step7Questionnaire',
  components: {
    QuestionnaireComponent,
  },
  data() {
    return {
      // TODO find a way to get these fields from a .json file or the drupal site.
      questionnaire: [
        {
          prompt:
            'What are some things you need to do to be a responsible homeowner?',
          type: 'multipleChoice',
          options: [
            'Pay your mortgage on time',
            'Pay your property taxes on time',
            'Keep up with the general repairs and maintenance',
            'Avoid making updates to the home',
          ],
          correctAnswer: [0, 1, 2],
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            "Paying your mortgage and property taxes on time is absolutely crucial. By missing payments, you could put yourself in a risky financial position that could result in losing your home to foreclosure. It is also very important to maintain your home so that manageable issues don't later become big repairs. This will not only keep your home safe but may also help preserve its value.",
        },
        {
          prompt:
            'Homeowners insurance usually does NOT cover damage from disasters like flooding and earthquakes.',
          type: 'singleChoice',
          options: ['True', 'False'],
          correctAnswer: 0,
          bottomHeaderTrue: 'Excellent job!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'Most of the time homeowners insurance will not covers damages caused by natural disasters. Make sure to review your policy to see what is covered and what deductibles are required.',
        },
        {
          prompt: 'Why is it important to maintain your home inside and out?',
          type: 'singleChoice',
          options: [
            'Neglect could decrease the value of your home',
            'Repairs could cost more down the road',
            'Keeps the home safe',
            'All the above',
          ],
          correctAnswer: 3,
          bottomHeaderTrue: 'Correct!',
          bottomHeaderFalse: 'Incorrect.',
          bottomText:
            'All of these are important reasons to maintain your home. This will probably be one of the biggest purchases you will ever make, so keeping it in good condition will protect your investment.',
        },
      ],
    };
  },
};
</script>

<style>
</style>
